module.exports = __webpack_public_path__ + "static/media/logo-prowin-messenger.4902d763.svg";